export function initApplicationPayment() {
    // Initialization code for the payment module
    // goToZahsRegistrationPaymentButton
    const btn = document.getElementById('goToZahsRegistrationPaymentButton');
    const result = window.parent.document.getElementById('lbResult');
    if (result && result.textContent.trim() !== "") {
        // hide payment elements
        hiddenPaymentElements();
        // Set values to span elements from parent
        setValuesToSpanElementsFromParent();
    } else {
        if (btn) {
            btn.addEventListener('click', function() {
                // Logic to redirect to the Zahs registration payment page
                const parentBtn = window.parent.document.getElementById('btnGoToStripePaymentPage');
                if (parentBtn) {
                    parentBtn.click();
                } else {
                    console.error('Parent button not found');
                }
            });
        }
    }
}


function setValuesToSpanElementsFromParent() {
    /* Get values from the parent and set values to span elements on the iframe
        <span id="lbHdr"></span>
        <span id="lbError"></span>
        <span id="lbResult"></span>
        <span id="lbPaymentInfo"></span>
    */
   const elements = [
        'lbHdr',
        'lbError',
        'lbResult',
        'lbPaymentInfo'
    ];
    elements.forEach(function(id) {
        const el = document.getElementById(id);
        const parentEl = window.parent.document.getElementById(id);
        if (el && parentEl) {
            el.textContent = parentEl.textContent;
        } else {
            console.error(`Element with id ${id} not found in iframe or parent.`);
        }
    });
}

function hiddenPaymentElements() {
    // Hide payment elements if the error message is present
    const elements = [
        'almostThere',
        'applicationConfirmation1',
        'goToZahsRegistrationPaymentButton',
        'applicationConfirmationText',
        'applicationConfirmationText2',
        'applicationConfirmationText3'
    ];
    elements.forEach(function(id) {
        const el = document.getElementById(id);
        if (el) {
            el.style.display = 'none';
        }
    });
}
